import { shade } from 'polished';
import styled from 'styled-components';

export const Conteiner = styled.div`


`;